import React, { useEffect, useState } from "react";
import useResponsive from "../../../../Hooks/useResponsive";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Stack,
  TextField,
} from "@mui/material";
import GlobalMultiSelect from "../../../../components/mui/GlobalMultiSelect";
import DatePickerCustom from "../../../../components/DatePicker/DatePickerCustom";
import dayjs from "dayjs";
import GlobalSelectFieldWithoutFormikNew from "../../../../components/mui/GlobalSelectFieldWithoutFormikNew";
import {
  AddButton,
  DeleteButton,
} from "../../../../components/mui/Buttons/Buttons";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import {
  bookSeat,
  getAllTransportaionList,
  removeSeat,
} from "../../../../redux/features/trasportationSlice";

const offices = [
  { value: "Pathanapuram", id: 6 },
  { value: "office2", id: 7 },
];

const BookingComponent = ({
  date,
  shiftId,
  closeButtonFunction,
  dispatchParams,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch("");
  const [direction, setDirection] = useState("row");
  const mdDown = useResponsive("down", "md");
  const [selectedOffice, setSelectedOffice] = useState(6);
  const [selectedDate, setSelectedDate] = useState(date);
  const [selectedTimeSlotObject, setSelectedTimeSlotObject] = useState({});
  const [userAlreadyBooked, setUserAlreadyMarked] = useState(false);
  const [alreadyMarkedObjectDetails, setAlreadyMarkedObjectDetails] = useState(
    {}
  );

  const { checkedShiftData, loading } = useSelector(
    (store) => store.transportation
  );
  const [
    selectedSlotDetailsFilteredObject,
    setSelectedSlotDetailsFilteredObject,
  ] = useState({}); //IT WILL STORE THE SELECTED SLOT DETAILS TO SHOW THE CAPACITY AND REMAINING ETC..

  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);

  useEffect(() => {
    setSelectedSlotDetailsFilteredObject([]); //CLEARING PREVIOUS DATA
    setSelectedTimeSlotObject({}); //CLEARING PREVIOUS DATA
    if (checkedShiftData.length > 0) {
      //CHECKED SHIFT DATA MEANS MORNING OR EVENING DATA AND IT WILL GIVE ARRAY OF OBJECTS AND WE WILL GET EACH TIME SLOTS OF SELECTED SHIFT AND IF THE USER ALREADY MARKED THEN THAT SLOT OBJCT HAS A FELD "ISmARKED" IT WILL GET AS 1 THEN WE CAN FIND AND FILTEER IT
      const markedObject = checkedShiftData.find((slot) => slot.isMarked == 1);
      setUserAlreadyMarked(markedObject && !!Object.keys(markedObject)?.length); //IF IT FOUND AS IS MARKED THEN USERALREADY MARKED AS MAKE IT AS A TRUE ITS A BOOLEAN STATE
      setAlreadyMarkedObjectDetails(markedObject); //USER ALREADY MARKED SLOT WILL BE STORED IN THIS STATE
      if (markedObject && !!Object.keys(markedObject)?.length) {
        setSelectedTimeSlotObject({
          id: markedObject.slotId,
          value: markedObject.slotName,
        });
      }
    }
  }, [checkedShiftData]);

  useEffect(() => {
    if (selectedTimeSlotObject?.id && checkedShiftData?.length > 0) {
      const filtered = checkedShiftData.filter(
        (data) => data.slotId == selectedTimeSlotObject?.id
      );
      if (filtered?.length > 0) {
        setSelectedSlotDetailsFilteredObject(filtered[0]);
      }
    }
  }, [selectedTimeSlotObject]);

  const handleOfficeSlotChange = (e) => {
    setSelectedOffice(e.target.value);
  };

  const bookSeatAction = () => {
    const data = {
      slotId: selectedTimeSlotObject?.id,
      date: selectedDate,
      shiftId: shiftId,
      officeId: selectedOffice,
    };
    dispatch(bookSeat(data)).then((res) => {
      if (res.payload.status == "failed" || res.payload.status == "error") {
        enqueueSnackbar(` ${res.payload.message}`, {
          variant: "error",
        });
      } else {
        enqueueSnackbar(` ${res.payload.message}`, {
          variant: "success",
        });
        dispatch(getAllTransportaionList(dispatchParams));
        closeButtonFunction();
      }
    });
  };

  const removeReservedSeat = () => {
    dispatch(removeSeat(alreadyMarkedObjectDetails?.transportId)).then(
      (res) => {
        if (res.payload.status == "failed" || res.payload.status == "error") {
          enqueueSnackbar(`${res.payload.message}`, { variant: "error" });
        } else {
          dispatch(getAllTransportaionList(dispatchParams));
          closeButtonFunction();
          enqueueSnackbar(` ${res.payload.message}`, {
            variant: "success",
          });
        }
      }
    );
  };

  return (
    <>
      {loading ? (
        <Stack
          direction={direction}
          gap={2}
          sx={{
            width: "100%",
            justifyContent: "space-between",
            alignItems: mdDown ? "start" : "center",
            padding: 1,
          }}
        >
          <Skeleton variant="rectangular" width={210} height={60} />
          <Skeleton variant="rectangular" width={180} height={60} />
          <Skeleton variant="rounded" width={210} height={60} />
          <Skeleton variant="square" width={80} height={40} />
        </Stack>
      ) : (
        <Box p={1}>
          <Box>
            <Stack mb={2} direction={direction} gap={1}>
              <Box flex={1}>
                <GlobalSelectFieldWithoutFormikNew
                  keys={{ itemId: "slotId", itemValue: "slotName" }}
                  label={"Time Slots"}
                  data={checkedShiftData}
                  selectedDetails={selectedTimeSlotObject}
                  setChange={setSelectedTimeSlotObject}
                  fullWidth={true}
                />
              </Box>
              <Box flex={1}>
                <DatePickerCustom
                  disabled
                  fullWidth={true}
                  value={dayjs(selectedDate)}
                  setValue={(date) =>
                    setSelectedDate(date.format("YYYY-MM-DD"))
                  }
                  viewDetails={["year", "month", "day"]}
                  error={false}
                />
              </Box>
            </Stack>
          </Box>

          <Stack direction={direction} gap={1}>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Box>
                <TextField
                  //   sx={{ width: "110px" }}
                  label="Max Capacity"
                  value={selectedSlotDetailsFilteredObject?.slotCapacity || ""}
                  disabled
                />
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Box>
                <TextField
                  //   sx={{ width: "130px" }}
                  label="Remaining Seats"
                  value={
                    selectedSlotDetailsFilteredObject?.remainingCapacity ?? ""
                  }
                  disabled
                />
              </Box>
              <Box>
                <FormControl>
                  <InputLabel>Office</InputLabel>
                  <Select
                    // sx={{ width: "160px" }}
                    name="offices"
                    label="offices"
                    value={selectedOffice}
                    onChange={handleOfficeSlotChange}
                    disabled
                  >
                    {offices?.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </Stack>
          <Box mt={1}>
            {userAlreadyBooked ? (
              <DeleteButton action={removeReservedSeat}>Remove</DeleteButton>
            ) : (
              <>
                {selectedTimeSlotObject?.id && ( //SHOULD BE SELECT A TIME SLOT TO SHOW ADD BUTTON OTHERWISE ITS NOT VISIBLE
                  <AddButton
                    disabled={
                      loading ||
                      selectedSlotDetailsFilteredObject?.remainingCapacity <=
                        0 ||
                      userAlreadyBooked
                    }
                    action={bookSeatAction}
                    size={"large"}
                  >
                    Reserve Seat
                  </AddButton>
                )}
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

export default BookingComponent;
